import React from "react";
import Menu from "@mui/material/Menu";
import Log from "./Log";
import Clone from "./Clone";
import Delete from "./Delete";
import Start from "./Startlab";
import Stop from "./Stoplab";
import SupportTeam from "./SupportTeam";
import UnCordoned from "./UnCordoned";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function SimpleMenu(props) {
  const { InstanceID, name, status, spent, budget,lab_id, billingtype, start_date, start_time, end_date, end_time,  machine_count, number_of_trainee,application } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Log InstanceID={InstanceID} />
        {status === "Failed" || status === "failed_con_create" || status === "failed_con_update" || status === "failed_cordon" || status === "failed_start" ||
        status === "failed_stop" || status === "failed_remove" || status === "failed_add" || status === "Start Initiated" || status === "Stop Initiated" ||
        status === "Cordoned" ||
        status === "Creating" ||
        status === "Running" ||
        status === "Retrying" ||
        status === "Stopping" ? (
          ""
        ) : (
          <Start
            InstanceID={InstanceID}
            status={status}
            spent={spent}
            budget={budget}
            billingtype={billingtype}
          />
        )}
        {status === "Failed" || status === "failed_con_create" || status === "failed_con_update" || status === "failed_cordon" || status === "failed_start" ||
        status === "failed_stop" || status === "failed_remove" || status === "failed_add" || status === "Start Initiated" || status === "Stop Initiated" ||
        status === "Cordoned" ||
        status === "Creating" ||
        status === "Stopped" ||
        status === "Retrying" ||
        status === "Stopping" ? (
          ""
        ) : (
          <Stop InstanceID={InstanceID} status={status} />
        )}
        {status === "Creating" ||
        status === "Retrying" ||
        status === "Stopping" ? (
          ""
        ) : (
          <Delete InstanceID={InstanceID} name={name} status={status} />
        )}
        {status === "Cordoned" ? (
          <UnCordoned
            InstanceID={InstanceID}
            name={name}
            status={status}
            spent={spent}
            budget={budget}
            start_date={start_date}
            start_time={start_time}
            end_date={end_date}
            end_time={end_time}
            billingtype={billingtype}
            number_of_trainee={number_of_trainee}
            application={application}
            lab_id={lab_id}
          />
        ) : (
          ""
        )}
        <SupportTeam status={status} />
        {status === "Failed" || status === "failed_con_create" || status === "failed_con_update" || status === "failed_cordon" || status === "failed_start" ||
        status === "failed_stop" || status === "failed_remove" || status === "failed_add" || status === "Start Initiated" || status === "Stop Initiated" ||
        status === "Cordoned" ||
        status === "Creating" ||
        status === "Stopping" ? (
          ""
        ) : (
          <Clone
            InstanceID={InstanceID}
            status={status}
            name={name}
            spent={spent}
            budget={budget}
          />
        )}
      </Menu>
    </div>
  );
}